export default "__VITE_ASSET__DUKxbZ91__"